import React from "react";
import Link from "gatsby-link";
// import ClassNames from 'classnames'

class CTA extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, callToAction, callToActionLink } = this.props;
    return (
      <div className="CTA">
        <div className="internal">
          <h2>{title}</h2>
          <Link to={callToActionLink} className="Btn orange-white">
            {callToAction}
          </Link>
        </div>
        <div className="cta-bg">
          <img src="/images/home/cta-product-bg.jpg" alt="" />
        </div>
      </div>
    );
  }
}

export default CTA;



// WEBPACK FOOTER //
// ./src/home/cta.js